module.exports = __webpack_public_path__ + "img/11.99011812.png";